var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.3121 0.388672H7.7C3.104 0.388672 0.5 2.99267 0.5 7.58867V20.1887C0.5 24.7847 3.104 27.3887 7.7 27.3887H20.3121C24.908 27.3887 27.5 24.7847 27.5 20.1887V7.58867C27.5 2.99267 24.908 0.388672 20.3121 0.388672Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.5463 12.4219V18.0485C19.5463 20.1585 18.843 20.8619 16.733 20.8619H11.1063C8.9963 20.8619 8.29297 20.1585 8.29297 18.0485V12.4219H19.5463Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6211 10.3129V11.0162C20.6211 11.7899 20.2484 12.4229 19.2145 12.4229H8.66448C7.58838 12.4229 7.25781 11.7899 7.25781 11.0162V10.3129C7.25781 9.53925 7.58838 8.90625 8.66448 8.90625H19.2145C20.2484 8.90625 20.6211 9.53925 20.6211 10.3129Z",
    fill: "#CE2600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.6856 8.90512H9.80313C9.564 8.64488 9.57103 8.24398 9.82423 7.99078L10.823 6.99205C11.0832 6.73182 11.5122 6.73182 11.7725 6.99205L13.6856 8.90512Z",
    fill: "#CE2600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.0699 8.90512H14.1875L16.1006 6.99205C16.3608 6.73182 16.7898 6.73182 17.0501 6.99205L18.0488 7.99078C18.302 8.24398 18.309 8.64488 18.0699 8.90512Z",
    fill: "#CE2600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M11.7891 12.4219V16.037C11.7891 16.5997 12.408 16.9302 12.8793 16.6278L13.5404 16.1917C13.7795 16.037 14.082 16.037 14.3141 16.1917L14.94 16.6137C15.4042 16.9232 16.0302 16.5926 16.0302 16.03V12.4219H11.7891Z",
    fill: "#CE2600"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/Product.d079265072e6fbef632cd2e719ddfb0f.svg";
export { ForwardRef as ReactComponent };